<template>
  <div  v-if="props.component">
    <a-row :gutter="10" class="padding bg-white text-grey ">
            <a-col :span="24" class="padding-tb-xs">
                 <span class="text-primary text-bolder">No.</span><span >{{ props.component.identifier }}</span>
            </a-col>
            <a-col :span="12" class="padding-tb-xs">
                 类型：{{ props.component.type }}
            </a-col>
            <a-col :span="12" class="padding-tb-xs">
                 类型：{{ props.component.type }}
            </a-col>
            <a-col :span="12" class="padding-tb-xs">
                 X：{{  props.component.style.position.x }}
            </a-col>
            <a-col :span="12" class="padding-tb-xs">
                 Y：{{ props.component.style.position.y  }}
            </a-col>
            <a-col :span="12" class="padding-tb-xs">
                 宽：{{ props.component.style.position.w }}
            </a-col>
            <a-col :span="12" class="padding-tb-xs">
                 高：{{ props.component.style.position.h }}
            </a-col>
          </a-row>
      <a-tabs v-model:activeKey="tabIndex">
        <a-tab-pane :key="0" tab="样式"></a-tab-pane>
        <a-tab-pane :key="1" tab="数据"></a-tab-pane>
        <a-tab-pane :key="2" tab="行为"></a-tab-pane>
      </a-tabs>
      <formsingle v-show="tabIndex==0" :data="props.component" :rules="componentRules" :submit="submit">
        <template #before>

        </template>
      </formsingle>
      <div v-show="tabIndex==1">根据实际数据设置</div>
      <div  v-show="tabIndex==2">
        <div class="devider">
          <div class="flex align-center  padding-tb-xs">
            <span class="margin-right">事件</span>
            <a-select class="flex1"  :fieldNames="{label:'name',value:'value'}" :options="[{name:'点击',value:'click'},{name:'双击',value:'dblclick'},{name:'鼠标移入',value:'mouseenter'}]"></a-select>
          </div>
          <div  class="flex align-center  padding-tb-xs">
            <span class="margin-right">动作</span>
            <a-select class="flex1" :fieldNames="{label:'name',value:'value'}" :options="[{name:'打开链接',value:'link'},{name:'赋值变量',value:'val'},{name:'展示隐藏',value:'visible'},{name:'调用服务',value:'service'}]"></a-select>
          </div>

        </div>
      </div>
  </div>
</template>
<script lang="ts" setup>
  import formsingle from '@/components/lanseed/formsingle.vue'
  import {ref,defineEmits,defineProps} from 'vue'
  const emits = defineEmits(['update:component'])
  const props = defineProps({
    component:{type:Object,default:()=>{return null}}
  })

const fontFamilyOptions=ref<Array>(['Arial', "Helvetica", "sans-serif", "宋体", "黑体", "微软雅黑"])
const textAlignOptions=ref<Array>(["left", "right", "center", "justify"])
const borderStyleOptions=ref<Array>(["solid", "dashed", "dotted"])
const whOptions=ref<Array>(['1024x768', '1366x768', '1280x800', '1440x900', '1600x900', '1920x1080', 'custom'])
const tabIndex=ref<Number>(0)
const componentRules=ref<Object>({
  /*
  identifier:{name:'编号',domtype:'text'},
  type:{name:'类型',domtype:'text'},
  'style.position.x':{name:'X',domtype:'text'},
  'style.position.y':{name:'Y',domtype:'text'},
  'style.position.w':{name:'宽',domtype:'text'},
  'style.position.h':{name:'高',domtype:'text'},
  */
   name:{name:'名称',required:true},
  'style.position.borderWidth':{name:'边框宽度',domtype:'number'},
  'style.position.borderStyle':{name:'边框样式',domtype:'select',data:borderStyleOptions.value},
  'style.position.borderColor':{name:'边框颜色',domtype:'color',max:30},
  'style.radius':{name:'圆角大小',domtype:'number'},
  'style.lineWidth':{name:'线宽',domtype:'number'},
  'style.setLineDash':{name:'虚线',domtype:'number'},
  'style.animations':{name:'动画',domtype:'select',data:[{ text: '向上', id: 'up' }, { text: '向下', id: 'down' },{ text: '向右', id: 'right' }, { text: '向左', id: 'left' }]},
  'style.dotSpace':{name:'动画空间',domtype:'number'},
  'style.dotWidth':{name:'动画线宽',domtype:'number'},
  'style.text':{name:'文本'},
  'style.textAlign':{name:'对齐方式',domtype:'select',data:textAlignOptions.value},
  'style.fontSize':{name:'字号',type:'number'},
  'style.foreColor':{name:'文字色',domtype:'color',max:30},
  'style.backColor':{name:'背景色',domtype:'color',max:30},
  'style.url':{name:'背景图',domtype:'img'},
  'style.visible':{name:'显隐',domtype:'switch'},
  'style.transform':{name:'角度',domtype:'slider',max:360},
})
function changeTab (_index) {
      tabIndex.value = _index;
}
function submit(d){
  emits('update:component',d)
}
</script>
<style lang="less" scoped>
   a-col{padding:5px 0;}
</style>
